// jshint esversion: 8
import ApiFactory from '../../../api/ApiFactory';
import amplitude from 'amplitude-js';
import axios from 'axios';
const LoginApi = ApiFactory.get('login');
const LogoutApi = ApiFactory.get('logout');
const UserApi = ApiFactory.get('users');

const login = async ({ commit, dispatch }, payload) => {
  let d, t;
  const env = process.env.NODE_ENV;
  let url;
  switch (env) {
    case 'production':
      url = process.env.VUE_APP_AUTH_URL;
      break;
    case 'staging':
      url = 'https://busie-auth-staging.herokuapp.com/auth/v1/login';
      break;
    case 'development':
      url ='https://busie-auth-staging.herokuapp.com/auth/v1/login'
      // url = 'http://localhost:3001/auth/v1/login';
      break;
    default:
      url = undefined;
  }
  if (url) {
    // use new url in production, staging, dev environments
    const res = await axios.post(url, payload);
    const { data } = res;
    const { token, expire, username, range_user } = data;
    const { department, location } = range_user;
    dispatch(
      'app/startRefreshTimer',
      { expire, token, department, location, username },
      { root: true }
    );
    d = data;
    t = token;
  } else {
    // TODO: come back to this method (without generating token here) when gateway is in production.
    const { data } = await LoginApi.post(payload);
    const token = Math.random().toString(36).substring(7);
    d = data;
    t = token;
  }
  // creates a new amplitude session on user login, adds RangeUser.id as userid
  // amplitude.getInstance().logEvent('EVENT') to use from here.
  const a = amplitude.getInstance();
  a.init(process.env.VUE_APP_AMPLITUDE, d.range_user.id);
  a.logEvent('LOGIN');
  commit('SET_TOKEN', t);
  return { data: d };
};

const logout = async ({ commit }) => {
  const { data } = await LogoutApi.post({ });
  commit('SET_TOKEN', null);
  return { data };
};

const register = async ({ commit }, payload) => await UserApi.post(payload);

const refresh = async ({ commit, dispatch, getters }, payload) => {
  /*
    param: payload { username, department, location }

    gets token from local state and sets as request header then makes request
    to refreshToken auth endpoint. sets new refresh timer and and commits new
    token
  */
  const { username, department, location } = payload;
  const env = process.env.NODE_ENV;
  const url = env === 'production' ?
    'https://busie-auth.herokuapp.com/auth/v1/refresh' :
    'http://localhost:3000/auth/v1/refresh';
  const headers = { authorization: getters.token };
  const { data } = await axios.post(url, payload, { headers });
  const { expire } = data;
  dispatch(
    'app/startRefreshTimer',
    { expire, username, department, location },
    { root: true }
  );
  commit('SET_TOKEN', data.token);
};

export default {
  login,
  logout,
  register,
  refresh
};
